import React from 'react';
import './style.css';

export default ({href, children, onClick, disabled = false, title}) => <a title={title} className={'Button' + (disabled ? ' Button-disabled' : '')} href={disabled ? null : href} onClick={onClick}>{children}</a>;


// WEBPACK FOOTER //
// ./src/common/input/Button/index.js